
import { Component, Vue } from 'vue-property-decorator'
import { AppModule, DeviceType } from '@/store/modules/app'
import { TicketsModule } from '@/store/modules/tickets'
import editTutor from '@/views/newOrderCaiGouGuanLi/tutor.vue'
import manualAdministration from '@/views/newOrderCaiGouGuanLi/manualWork.vue'

@Component({
  name: 'editDialogCggl',
  components: {
    editTutor,
    manualAdministration
  }
})
export default class extends Vue {
  get device() {
    return AppModule.device
  }

  get classObj() {
    return {
      mobile: this.device === DeviceType.Mobile
    }
  }

  get dialogVisible() {
    return TicketsModule.editAdministrationDialog
  }

  get currentTicket() {
    return TicketsModule.currentTicket || {}
  }

  // 正在操作的工单index
  get ticketIndex() {
    return TicketsModule.currentTicketIndex || 0
  }

  // 关闭弹框
  private handleClose() {
    TicketsModule.ToggleDialogStatus({
      name: 'editAdministrationDialog',
      value: false
    })
  }

  private handleSuccess(res: any) {
    this.$emit('handleSuccess', res)
  }

  mounted() {
    console.log(this.currentTicket, 4444)
  }
}
